import { render, staticRenderFns } from "./mudar-senha.vue?vue&type=template&id=133c489b&scoped=true&"
import script from "./mudar-senha.vue?vue&type=script&lang=js&"
export * from "./mudar-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c489b",
  null
  
)

export default component.exports